import BuilderView from '../Builder/View';
import { withRailsContext } from '../RailsContext';

export default withRailsContext(BuilderView);
